import React from 'react'
import { useSetState } from 'react-use'
import { flowRight } from 'lodash'
import { graphql } from '@apollo/client/react/hoc'
import { fetchPolicy } from 'lib/apolloFetchPolicy'

import LoadingIndicator from 'components/LoadingIndicator'
import ErrorComponent from 'components/Errors/ErrorComponent'
import EventForm from 'components/Events/EventForm/EventForm'
import VehicleFuelConsumption from 'components/Vehicles/VehicleFuelConsumption/VehicleFuelConsumption'

import getRefillEventFormData from 'graphql/event/getRefillEventFormData.gql'

export const RefillEventFormContext = React.createContext()

const REFILL_FORM_MODE = Object.freeze({
    DEFAULT: 'default',
    CALCULATE_FUEL_CONSUMPTION: 'calculateFuelConsumption',
})

const RefillEventForm = ({ data }) => {
    const { loading, error, vehicle } = data

    const [state, setState] = useSetState({
        mode: REFILL_FORM_MODE.DEFAULT,
        event: null,
    })

    const { mode, event } = state

    if (error) return <ErrorComponent />
    if (loading) return <LoadingIndicator />

    const renderMode = () => {
        switch (mode) {
        case REFILL_FORM_MODE.DEFAULT:
            return (
                <EventForm
                    onSubmitted={({ event }) => {
                        // only try to do fuel consumption calculation when filled up event saved
                        if (event.eventData.fuelFilledUp) {
                            setState({
                                mode: REFILL_FORM_MODE.CALCULATE_FUEL_CONSUMPTION,
                                event: event,
                            })

                            // return true to ignore the EventForm default submitted logic
                            return true
                        }

                        return false
                    }}
                />
            )
        case REFILL_FORM_MODE.CALCULATE_FUEL_CONSUMPTION:
            return (
                <VehicleFuelConsumption
                    eventId={event.id}
                    mileage={event.eventData.mileage}
                    vehicleId={vehicle.id}
                    onBackToEdit={() => setState({ mode: REFILL_FORM_MODE.DEFAULT })}
                />
            )
        }
    }

    return (
        <RefillEventFormContext.Provider value={{ vehicle: vehicle }}>
            {renderMode()}
        </RefillEventFormContext.Provider>
    )
}

export default flowRight(
    graphql(getRefillEventFormData, {
        options: ({ vehicleId }) => ({
            variables: {
                vehicleId,
            },
            fetchPolicy: fetchPolicy.NETWORK_ONLY,
        }),
    }),
)(RefillEventForm)
